var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40.446053mm",
    height: "29.707947mm",
    viewBox: "0 0 40.446053 29.707947",
    id: "svg232",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs229"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-67.551401,-118.0616)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect4991",
    style: {
      fill: "#162d50",
      strokeWidth: 0.264583
    },
    ry: 0.76924956,
    height: 5.3689251,
    width: 7.5162835,
    y: 142.4006,
    x: 67.551399
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect4993",
    style: {
      fill: "#162d50",
      strokeWidth: 0.264583
    },
    ry: 0.76924956,
    height: 5.3689251,
    width: 7.5162835,
    y: 142.4006,
    x: 75.783646
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect4995",
    style: {
      fill: "#162d50",
      strokeWidth: 0.264583
    },
    ry: 0.76924956,
    height: 5.3689251,
    width: 7.5162835,
    y: 142.4006,
    x: 84.015892
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect4997",
    style: {
      fill: "#162d50",
      strokeWidth: 0.264583
    },
    ry: 0.76924956,
    height: 5.3689251,
    width: 7.5162835,
    y: 142.4006,
    x: 92.247345
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect4999",
    style: {
      fill: "#162d50",
      strokeWidth: 0.264583
    },
    ry: 0.76924956,
    height: 5.3689251,
    width: 7.5162835,
    y: 142.4006,
    x: 100.48117
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect5001",
    style: {
      fill: "#162d50",
      strokeWidth: 0.264583
    },
    ry: 0.76924956,
    height: 5.3689251,
    width: 7.5162835,
    y: 136.31519,
    x: 75.783646
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect5003",
    style: {
      fill: "#162d50",
      strokeWidth: 0.264583
    },
    ry: 0.76924956,
    height: 5.3689251,
    width: 7.5162835,
    y: 136.31519,
    x: 84.015892
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect5005",
    style: {
      fill: "#162d50",
      strokeWidth: 0.264583
    },
    ry: 0.76924956,
    height: 5.3689251,
    width: 7.5162835,
    y: 136.31519,
    x: 92.247345
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect5007",
    style: {
      fill: "#162d50",
      strokeWidth: 0.264583
    },
    ry: 0.76924956,
    height: 5.3689251,
    width: 7.5162835,
    y: 136.31519,
    x: 100.48117
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect5009",
    style: {
      fill: "#162d50",
      strokeWidth: 0.264583
    },
    ry: 0.76924956,
    height: 5.3689251,
    width: 7.5162835,
    y: 130.22977,
    x: 75.783646
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect5011",
    style: {
      fill: "#162d50",
      strokeWidth: 0.264583
    },
    ry: 0.76924956,
    height: 5.3689251,
    width: 7.5162835,
    y: 130.22977,
    x: 84.015892
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect5013",
    style: {
      fill: "#162d50",
      strokeWidth: 0.264583
    },
    ry: 0.76924956,
    height: 5.3689251,
    width: 7.5162835,
    y: 130.22977,
    x: 92.247345
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect5015",
    style: {
      fill: "#162d50",
      strokeWidth: 0.264583
    },
    ry: 0.76924956,
    height: 5.3689251,
    width: 7.5162835,
    y: 124.147,
    x: 84.015892
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect5017",
    style: {
      fill: "#162d50",
      strokeWidth: 0.264583
    },
    ry: 0.76924956,
    height: 5.3689251,
    width: 7.5162835,
    y: 124.147,
    x: 92.247345
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect5019",
    style: {
      fill: "#162d50",
      strokeWidth: 0.264583
    },
    ry: 0.76924956,
    height: 5.3689251,
    width: 7.5162835,
    y: 118.06159,
    x: 84.015892
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ad286c9db7876bbfd3f0152fa53ac55b.svg";
export { ForwardRef as ReactComponent };